<template>
  <div class="content">
    <h1>About</h1>
    <p>Hi there!</p>
    <p>My name is Shannon and I'm so excited to share Share My Scrapbook with you! This application is actually my husband's Christmas present to me. He's a programmer (obviously) and was able to create this technological wonder for me!  He's spent long hours making my vision come true and I'm so excited about it! Since we are becoming minimalists and are trying to cut down on both physical possessions and expenses - and because we move around a lot and physical scrapbooks are heavy! - I wanted some way to look through my scrapbooks page by page. It needed to be simple, just the basics (although who knows what features we'll add in the future though!), so I could simply flip through as if I were sitting down with the printed copy. I'm proud of my hobby and love preserving memories of all of our friends and family with all of the wonderful adventures we've had together. Much of that family lives far from us, so I also wanted a way to share the albums that feature some of those far-away folks really easily.</p>
    <p>And so Share My Scrapbook was born. Our intention is to provide a simple, easy means for all of the wonderful digital scrapbookers out there to share their beautiful creations and beautiful memories with their loved ones. My husband told me that he'd be happy if I were the only one using this site… and of course I am!... but we'd love to share it with anyone else who would like to use it.</p>
    <p>Sincerely,<br />
    Shannon Collier<br />
    <em>Collector and preserver of moments</em></p>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="stylus" scoped>
.content 
  padding 0 30px
  max-width 1100px
  margin 0 auto
  
  p
    line-height 1.4em

h1
  border-bottom: 2px dotted #189ea6;
</style>
